
import './App.css'
import { BrowserRouter } from 'react-router-dom'
import RouteNavs from './Routes';
function App() {
  return (
    <BrowserRouter>
     <RouteNavs/>
     </BrowserRouter>
  );
}

export default App;

